import React from 'react';

import Snackbar from 'components/DesignSystem/Snackbar';
import DatePicker from 'components/DatePicker';
import Section from 'components/Meteorology/Shared/ControlPanelSheet/Section';
import { SectionState } from 'components/Meteorology/Shared/ControlPanelSheet/DetailedView/types';

export default function ForecastDateSection({
  forecastDate, open, onToggle,
}: SectionState & {
  forecastDate: {
    selectedDate: Date | null;
    setDate: (date: Date | null) => void;
    availableIntervals: { start: Date; end: Date }[];
  };
}) {
  return (
    <Section
      label="Data de previsão"
      valueText={forecastDate.selectedDate
        ? forecastDate.selectedDate.toLocaleDateString('pt-BR') : undefined}
      open={open}
      onToggle={onToggle}
    >
      {forecastDate.availableIntervals.length === 0 && (
        <Snackbar>
          Nenhuma data de previsão disponível para os parâmetros selecionados.
        </Snackbar>
      )}
      {forecastDate.availableIntervals.length > 0 && (
        <DatePicker
          inline
          showMonthDropdown
          showYearDropdown
          selected={forecastDate.selectedDate}
          onChange={forecastDate.setDate}
          includeDateIntervals={forecastDate.availableIntervals}
        />
      )}
    </Section>
  );
}
